import {Dispatcher} from "../../../stem-core/base/Dispatcher";
import {merchantService} from "../../../dashboard/misc/MerchantService.js";
import {toArray} from "../../../stem-core/base/Utils";
import {MerchantPanel} from "../merchant/MerchantPanelStore.js";
import {MerchantUserJourney} from "../merchant/MerchantUserJourneyStore.js";
import {Merchant} from "../MerchantStore";
import {MerchantSDKResource} from "./MerchantSDKResource";


export class LabelManager extends Dispatcher {
    merchant: Merchant;

    constructor(merchant: Merchant) {
        super();
        this.merchant = merchant;
    }

    getLabelsForSDKResource(sdkResource: MerchantSDKResource): string[] {
        return toArray(sdkResource.dashboardOptions.labels).filter(x => x);
    }

    // Return an array of Strings
    getLabels(): string[] {
        const labelFrequency = new Map<string, number>();

        const resources = [
            ...MerchantPanel.filterBy({merchantId: this.merchant.id}),
            ...MerchantUserJourney.filterBy({merchantId: this.merchant.id}),
        ]
        // TODO - make case insensitive the label name
        for (const obj of resources) {
            const objLabels = this.getLabelsForSDKResource(obj);
            for (const label of objLabels) {
                const currentCount = labelFrequency.get(label) || 0;
                labelFrequency.set(label, currentCount + 1);
            }
        }
        const result = Array.from(labelFrequency.keys());
        // Sort by frequency
        result.sort((l1, l2) => labelFrequency.get(l1)! - labelFrequency.get(l2)!);
        return result;
    }
}

const labelManagerMap: WeakMap<Merchant, LabelManager> = new WeakMap();

export function GetLabelManager(merchant: Merchant): LabelManager {
    let labelManager = labelManagerMap.get(merchant);
    if (!labelManager) {
        labelManager = new LabelManager(merchant);
        labelManagerMap.set(merchant, labelManager);
    }
    return labelManager;
}

declare global {
    interface Window {
        getLabelManager: () => LabelManager;
    }
}

window.getLabelManager = () => GetLabelManager(merchantService.getMerchant());
